import { useEffect, useMemo, useState } from 'react';
import { recapSaveState } from '../recap/recapSaveState';

/**
 * The save-state phrase for the topbar Recap button, recomputed on every
 * change of the drafts hook's state and once every 30 seconds so "Saved just
 * now" ages into "Saved 2 min ago" without a keystroke.
 */
const TICK_MS = 30 * 1000;

const useRecapSaveState = (recap) => {
	const [now, setNow] = useState(() => Date.now());
	useEffect(() => {
		const id = setInterval(() => setNow(Date.now()), TICK_MS);
		return () => clearInterval(id);
	}, []);
	return useMemo(
		() => recapSaveState({ tiers: recap?.tiers, hasUnsavedChanges: Boolean(recap?.hasUnsavedChanges), now }),
		[recap?.tiers, recap?.hasUnsavedChanges, now]
	);
};

export default useRecapSaveState;
